import type * as Types from 'app/types/graphql';

export type CampaignSelectFragment = Pick<
  Types.Campaign,
  | 'id'
  | 'name'
  | 'type'
  | 'status'
  | 'priority'
  | 'storeDomain'
  | 'targetDevices'
  | 'targetChannels'
  | 'targetCountries'
  | 'targetVisitorTypes'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'startedAt'
  | 'deletedAt'
  | 'completedAt'
> & {
  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
  versions?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.SplitTestingCampaignVersion,
          'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
        >
      >
    >
  >;
};

export type CampaignTemplateSelectFragment = Pick<
  Types.Campaign,
  | 'id'
  | 'name'
  | 'type'
  | 'status'
  | 'priority'
  | 'storeDomain'
  | 'targetDevices'
  | 'targetChannels'
  | 'targetCountries'
  | 'targetVisitorTypes'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'startedAt'
  | 'deletedAt'
  | 'completedAt'
> & {
  variants?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.Variant,
          | 'id'
          | 'isOrigin'
          | 'isWinner'
          | 'trafficRate'
          | 'themePageID'
          | 'templateType'
          | 'templateSuffix'
          | 'createdAt'
          | 'deletedAt'
          | 'updatedAt'
          | 'winnerTemplateSuffix'
        > & {
          template?: Types.Maybe<
            Pick<
              Types.VariantTemplate,
              | 'createdAt'
              | 'deletedAt'
              | 'id'
              | 'redirectURL'
              | 'themeID'
              | 'updatedAt'
              | 'thumbnailURL'
              | 'title'
            >
          >;
          price?: Types.Maybe<
            Pick<
              Types.VariantPrice,
              | 'id'
              | 'baseID'
              | 'handle'
              | 'status'
              | 'title'
              | 'redirectURL'
              | 'sourceProductBaseID'
            >
          >;
          productVariants?: Types.Maybe<
            Array<
              Types.Maybe<
                Pick<
                  Types.VariantProductVariant,
                  'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                >
              >
            >
          >;
          url?: Types.Maybe<
            Pick<
              Types.VariantUrl,
              'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
            >
          >;
        }
      >
    >
  >;
  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
  versions?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.SplitTestingCampaignVersion,
          'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
        >
      >
    >
  >;
};

export type CampaignTemplateEdgeSelectFragment = Pick<Types.CampaignEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<
      Types.Campaign,
      | 'id'
      | 'name'
      | 'type'
      | 'status'
      | 'priority'
      | 'storeDomain'
      | 'targetDevices'
      | 'targetChannels'
      | 'targetCountries'
      | 'targetVisitorTypes'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'startedAt'
      | 'deletedAt'
      | 'completedAt'
    > & {
      variants?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.Variant,
              | 'id'
              | 'isOrigin'
              | 'isWinner'
              | 'trafficRate'
              | 'themePageID'
              | 'templateType'
              | 'templateSuffix'
              | 'createdAt'
              | 'deletedAt'
              | 'updatedAt'
              | 'winnerTemplateSuffix'
            > & {
              template?: Types.Maybe<
                Pick<
                  Types.VariantTemplate,
                  | 'createdAt'
                  | 'deletedAt'
                  | 'id'
                  | 'redirectURL'
                  | 'themeID'
                  | 'updatedAt'
                  | 'thumbnailURL'
                  | 'title'
                >
              >;
              price?: Types.Maybe<
                Pick<
                  Types.VariantPrice,
                  | 'id'
                  | 'baseID'
                  | 'handle'
                  | 'status'
                  | 'title'
                  | 'redirectURL'
                  | 'sourceProductBaseID'
                >
              >;
              productVariants?: Types.Maybe<
                Array<
                  Types.Maybe<
                    Pick<
                      Types.VariantProductVariant,
                      'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                    >
                  >
                >
              >;
              url?: Types.Maybe<
                Pick<
                  Types.VariantUrl,
                  'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
                >
              >;
            }
          >
        >
      >;
      group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
      versions?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.SplitTestingCampaignVersion,
              'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
            >
          >
        >
      >;
    }
  >;
};

export type CampaignVersionSelectFragment = Pick<
  Types.SplitTestingCampaignVersion,
  'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
>;

export const CampaignVersionSelectFragmentDoc = `
    fragment CampaignVersionSelect on SplitTestingCampaignVersion {
  id
  version
  settings
  startedAt
  completedAt
}
    `;
export const CampaignSelectFragmentDoc = `
    fragment CampaignSelect on Campaign {
  id
  group {
    id
    title
    type
  }
  name
  type
  status
  priority
  storeDomain
  targetDevices
  targetChannels
  targetCountries
  targetVisitorTypes
  conditions
  createdAt
  updatedAt
  startedAt
  deletedAt
  completedAt
  versions {
    ...CampaignVersionSelect
  }
}
    `;
export const CampaignTemplateSelectFragmentDoc = `
    fragment CampaignTemplateSelect on Campaign {
  ...CampaignSelect
  variants {
    ...VariantWithTemplateSelect
  }
}
    `;
export const CampaignTemplateEdgeSelectFragmentDoc = `
    fragment CampaignTemplateEdgeSelect on CampaignEdge {
  cursor
  node {
    ...CampaignTemplateSelect
  }
}
    `;
